<!--Note: This file should only contains NG-TEMPLATES-->
<!--Note: Here let-data to be the type of 'ICsDdTemplate'-->

<ng-container>
    <ng-template #basicTemplate let-data>
        <div class="dd-item"
             (click)="!data['isDisableItemClick'] && itemClick(data)"
             [ngClass]="{
                 'selected': data['isSelected'],
                 'pointer': !data['isDisableItemClick'],
                 'fav': data['isFavourite']
             }">
            <ng-container *ngIf="data['templateData']['iconsList']">
                <ng-container *ngFor="let icon of data['templateData']['iconsList']">
                    <div *ngIf="icon && icon['src'] && !icon['isHide']"
                         class="icon"
                         (click)="data['isDisableItemClick'] && icon['isIconClick'] && itemElementClick({elType: 'ICON', item: data, itemElement: icon})"
                         [ngClass]="{
                        'image': icon.type === 'IMAGE',
                        'box': icon.shape === 'BOX',
                        'pointer': data['isDisableItemClick'] && icon['isIconClick']
                     }">
                        <ng-container *ngIf="icon.type === 'IMAGE'">
                            <img [src]="icon.src" alt="" [ngClass]="{'circle': icon.shape === 'CIRCLE'}">
                        </ng-container>

                        <ng-container *ngIf="icon.type === 'CLASS_ICON'">
                            <span class="{{icon.src}}" [ngClass]="{'circle': icon.shape === 'CIRCLE'}"></span>
                        </ng-container>

                        <ng-container *ngIf="icon.type === 'FA_ICON'">
                            <i class="{{icon.src}}" [ngClass]="{'circle': icon.shape === 'CIRCLE'}"></i>
                        </ng-container>
                    </div>
                </ng-container>
            </ng-container>

            <div class="flex-1"
                (click)="data['isDisableItemClick']
                            && data['templateData']['isTextClick']
                            && itemElementClick({elType: 'TEXT', item: data})"
                 [ngClass]="{'pointer': data['isDisableItemClick'] && data['templateData']['isTextClick'],
                  'with-background': data['templateData']['background']}"
                 [style.background]="data['templateData']['background']">
                <span class="text" translate>{{data['templateData']['text']}}</span>
            </div>
        </div>
    </ng-template>
</ng-container>



